var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"Home"}},[_c('v-img',{attrs:{"src":"./aes_logo.png","contain":"","height":"100"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }